import { render, staticRenderFns } from "./VCategoriesTable.vue?vue&type=template&id=af136276"
import script from "./VCategoriesTable.vue?vue&type=script&lang=js"
export * from "./VCategoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports